import {CustomFieldValue} from "./race-registration/custom-field-value";

export class Competitor {
  id?: number;
  profileId?: number;
  raceId?: number;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  sex?: number;
  status?: CompetitorStatus;
  startPosition?: number;
  birthday?: Date;
  dayOfBirth?: number;
  monthOfBirth?: number;
  yearOfBirth?: number;
  category?: number;
  categoryLabel?: string;
  address?: string;
  placeOfResidence?: string;
  country?: string;
  identityCardNumber?: string;
  identityCardIssuer?: string;
  identityCardExpires?: Date;
  club?: string;
  mobilePhone?: string;
  emergencyPhone?: string;
  email?: string;
  emailToken?: string;
  emailTerified?: string;
  tshirt?: number;
  meal?: number;
  transport?: number;
  bestTime?: string;
  licence?: string;
  licenceType?: string;
  grouping?: string;
  comment?: string;
  startNumber?: string;
  startBlock?: number;
  presentAtStart?: boolean;
  chipNumber?: string;
  fee?: string;
  groupRegistrationCode?: string;
  promoCode?: string;
  eventAccommodationItemId?: number;
  accommodationFrom?: string;
  accommodationTo?: string;
  extra?: string;
  created?: Date;
  modified?: Date;
  userId?: number;
  zip?: string;
  discountId?: number;
  registrationId?: number;
  customFieldValues?: CustomFieldValue[];
  registrationFeeId?: number;
  additionalItemsId?: number[];
  discountCode?: number[];
}

export enum CompetitorStatus {
  REG = 1,
  BIB = 2,
  RDY = 3,
  STA = 4,
  FIN = 5,
  DSQ = 6,
  DNF = 7,
  TLE = 8,
  DNS = 9
}


